import {
  HTTP_UPDATEAPPROVE_FETCHING,
  HTTP_UPDATEAPPROVE_SUCCESS,
  HTTP_UPDATEAPPROVE_FAILED,
  server,
  OK,
  YES,
} from "./../../Constants";
import { httpClient } from "./../../utils/HttpClient";

//Update Special
export const setStateupdateApproveByIdToFetching = () => ({
  type: HTTP_UPDATEAPPROVE_FETCHING,
});

export const setStateupdateApproveByIdToSuccess = (payload) => ({
  type: HTTP_UPDATEAPPROVE_SUCCESS,
  payload,
});

export const setStateupdateApproveByIdToFailed = (payload) => ({
  type: HTTP_UPDATEAPPROVE_FAILED,
});

// export const updateBudgetOById = (budgetoid, memid, item) => {
export const updateApproveById = (id, memid) => {
  return async (dispatch) => {
    dispatch(setStateupdateApproveByIdToFetching());
    try {
      await httpClient.put(`${server.UPDATEAPPROVE_URL}/${id}/${memid}`);
      dispatch(setStateupdateApproveByIdToSuccess("success"));
    } catch (error) {
      dispatch(setStateupdateApproveByIdToFailed());
    }
  };
};
